import axios from "axios";
import apiMixin from "@/mixins/apiMixin";

export default {
  mixins: [apiMixin],
  methods: {
    async getFilters(take = [], filter = {}) {
      try {
        const url = `${this.apiUrl}/api/s/filter/v2 `;

        const response = await axios.post(
          url,
          { take, filter },
          { headers: this.requestHeaders }
        );

        if (response.status === 200) return response.data;
      } catch (e) {
        this.handleError(e);
        throw e;
      }
    },
  },
};
